export enum VariableTypeEnum {
    STRING = 'string'
}
